import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "~components/DataTable/types/dataTableFilter.ts";
import SelectAgeGroup from "~components/SelectAgeGroup";
import SelectDiscipline from "~components/SelectDiscipline/SelectDiscipline.tsx";
import SelectEntityStandard from "~components/SelectEntityStandard/SelectEntityStandard.tsx";
import SelectEntityStatus from "~components/SelectEntityStatus/SelectEntityStatus.tsx";
import SelectGender from "~components/SelectGender";
import { TableFilter } from "~enums/tableFilter.ts";
import { EntityTableFiltersTypes } from "~pages/Entities/EntitiesListPage/enums/entityTableFiltersTypes.ts";

export const useGetEntitiesTableFilters = (
  defaultFilter: Record<string, any> = {},
): {
  filters: DataTableFilter[];
  currentFilter: Record<string, any>;
  handleFilterChange: (updatedFilter: Record<string, any>) => void;
} => {
  const [currentFilter, setCurrentFilter] = useState<Record<string, any>>(defaultFilter);
  const { formatMessage } = useIntl();

  const handleFilterChange = useCallback((updatedFilter: Record<string, any>) => {
    setCurrentFilter(updatedFilter);
  }, []);

  const filters = [
    {
      filterKey: EntityTableFiltersTypes.Gender,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectGender
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.gender.allOption",
          })}
        />
      ),
    },
    {
      filterKey: EntityTableFiltersTypes.AgeGroup,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectAgeGroup
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.ageGroup.allOption",
          })}
        />
      ),
    },
    {
      filterKey: EntityTableFiltersTypes.Discipline,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectDiscipline
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.discipline.allOption",
          })}
        />
      ),
    },
    {
      filterKey: EntityTableFiltersTypes.Standard,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectEntityStandard
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.standard.allOption",
          })}
        />
      ),
    },
    {
      filterKey: EntityTableFiltersTypes.Status,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectEntityStatus
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.status.allOption",
          })}
        />
      ),
    },
  ];

  return {
    filters,
    currentFilter,
    handleFilterChange,
  };
};
